import { render, staticRenderFns } from "./CaretIcon.vue?vue&type=template&id=193ae0f9&"
import script from "./CaretIcon.vue?vue&type=script&lang=js&"
export * from "./CaretIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports